import { MedelyDateTime } from '@medely/date-time-tools';

export const isShiftWindowOpen = ({
  shiftWindow,
  startTime,
  timezone,
}: {
  shiftWindow?: number | null;
  startTime?: string | null;
  timezone: string;
}) => {
  if (!shiftWindow || !startTime) {
    return false;
  }

  const startDateTime = new MedelyDateTime(startTime, { tz: timezone });
  const now = new Date();
  const nowPlusWindowMs = now.getTime() + shiftWindow * 60 * 60 * 1000;
  const nowPlusWindow = new MedelyDateTime(new Date(nowPlusWindowMs).toISOString(), {
    tz: timezone,
  });

  return nowPlusWindow.isBefore(startDateTime);
};
